import CookieUtility from '../../../../utilities/CookieUtility.js';
/**
 * Cookie util.
 */
class AccountCookieUtility {
    /**
     * Deletes all cookies from document.
     */
    static deleteAllCookies() {
        CookieUtility.deleteAllCookies();
    }
    /**
     * Removes a cookie.
     *
     * @param name Name.
     */
    static removeCookie(name) {
        CookieUtility.removeCookie(this.getTokenName(name));
    }
    /**
     * Sets a session cookie.
     *
     * @param name Name.
     * @param value Value.
     */
    static setCookie(name, value) {
        CookieUtility.setCookie(this.getTokenName(name), value);
    }
    /**
     * Returns a cookie.
     *
     * @param name Name.
     * @returns Cookie value.
     */
    static getCookie(name) {
        return CookieUtility.getCookie(this.getTokenName(name));
    }
    static getTokenName(token) {
        return this.tokenPrefix + '_' + token;
    }
}
AccountCookieUtility.tokenPrefix = 'dexfAccount'; // Prefix used for all cookies
export default AccountCookieUtility;
//# sourceMappingURL=AccountCookieUtility.js.map